import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PeopleLockIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="peopleLock" ref={ref} {...props}>
      <path d="M21.47,15V13.82a2.18,2.18,0,0,0-2.18-2.17h-.47a2.17,2.17,0,0,0-2.17,2.17V15a2.24,2.24,0,0,0-1.45,2.1v1.33a2.25,2.25,0,0,0,2.25,2.25h3.21a2.25,2.25,0,0,0,2.25-2.25V17.12A2.24,2.24,0,0,0,21.47,15Zm-3.32-1.21a.67.67,0,0,1,.67-.67h.47a.68.68,0,0,1,.68.67v1H18.15ZM13.64,9.9A3.34,3.34,0,1,1,17,6.57,3.34,3.34,0,0,1,13.64,9.9Zm0-5.17a1.84,1.84,0,1,0,1.83,1.84A1.84,1.84,0,0,0,13.64,4.73Zm-5.5,11.5a.75.75,0,0,1-.75-.75,4.11,4.11,0,0,1,4.1-4.11H15a.75.75,0,0,1,0,1.5H11.49a2.6,2.6,0,0,0-2.6,2.61A.76.76,0,0,1,8.14,16.23ZM5.9,10.36A2.59,2.59,0,1,1,8.49,7.77,2.59,2.59,0,0,1,5.9,10.36Zm0-3.68A1.09,1.09,0,1,0,7,7.77,1.09,1.09,0,0,0,5.9,6.68ZM2,14.86a.75.75,0,0,1-.75-.75A3.14,3.14,0,0,1,4.37,11H6.7a.75.75,0,0,1,0,1.5H4.37a1.64,1.64,0,0,0-1.64,1.63A.75.75,0,0,1,2,14.86Z" />
    </Icon>
  ),
) as IconWithRender;

PeopleLockIcon.displayName = 'PeopleLockIcon';
PeopleLockIcon.renderIcon = (props) => <PeopleLockIcon {...props} />;
export default PeopleLockIcon;
